import { useMemo } from "react";
import { MessagingBridgeManagerMasterContextProvider } from "../../../contexts/messagingBridgeManagerProvider";
import { useSettings } from "../../../hooks/settings";
import RouteContainer, { RouteContainerProps } from "./RouteContainer";

export const MasterRouteContainer = ({ element, children }: RouteContainerProps) => {
  const [settings] = useSettings();
  
  const options = useMemo(() => ({
    enableBroadcast: settings.bridge?.master?.enableBroadcast ?? false,
    password: settings.secret?.localPassword ?? undefined,
  }), [settings]);

  return (
    <MessagingBridgeManagerMasterContextProvider
      options={options}
    >
      <RouteContainer element={element} children={children} />
    </MessagingBridgeManagerMasterContextProvider>
  );
};

export default MasterRouteContainer;
